export default ({ style, color = '#6c5bff' }) => (
  <svg width="11.252" height="11.252" viewBox="0 0 11.252 11.252" style={style}>
    <path
      d="M10.349,7.386a6.388,6.388,0,0,1-2.006-.32.917.917,0,0,0-.892.188l-1.265.955A6.992,6.992,0,0,1,3.042,5.066l.927-1.232a.909.909,0,0,0,.224-.921A6.4,6.4,0,0,1,3.872.9a.9.9,0,0,0-.9-.9H.9A.9.9,0,0,0,0,.9,10.361,10.361,0,0,0,10.349,11.252a.9.9,0,0,0,.9-.9V8.288A.9.9,0,0,0,10.349,7.386Z"
      fill={color}
    />
  </svg>
)
